import React, { Component } from "react";
import Desktop from "../../components/Desktop";
import Mobile from "../../components/Mobile";
import { connect } from "react-redux";
import { getSettings } from "../../services/settings/actions";
import { getAllLanguages, getSingleLanguageData } from "../../services/languages/actions";
import PushNotificationManager from "../PushNotificationManager";

class App extends Component {
  componentDidMount() {
    this.props.getSettings();
    this.props.getAllLanguages();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.languages !== nextProps.languages && Array.isArray(nextProps.languages) && nextProps.languages.length > 0) {
      console.log('Languages loaded, now loading language data...');
      const preferredLangId = localStorage.getItem("userPreferedLanguage");
      if (preferredLangId) {
        console.log('Loading preferred language:', preferredLangId);
        this.props.getSingleLanguageData(preferredLangId);
      } else {
        const defaultLang = nextProps.languages.find(lang => lang.is_default === 1);
        if (defaultLang) {
          console.log('Loading default language:', defaultLang.id);
          this.props.getSingleLanguageData(defaultLang.id);
        }
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <PushNotificationManager />
        {window.innerWidth <= 768 ? (
          <Mobile languages={this.props.languages} />
        ) : (
          <Desktop languages={this.props.languages} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.settings.settings,
  user: state.user.user,
  notification_token: state.notification_token.notification_token,
  languages: state.languages.languages,
});

export default connect(
  mapStateToProps,
  { getSettings, getAllLanguages, getSingleLanguageData }
)(App);
